import { useLocation, useNavigate } from 'react-router';

import Button from 'honeydew/Button';
import useGlobalStore from 'hooks/useGlobalStore';
import { trackEvent } from 'utils/analyticsUtils';
import { setSignupLocalStorage } from 'utils/signupUtils';

export function CreateAccountButton() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isMisfitsTheme } = useGlobalStore();

    const handleCreateAccount = () => {
        const domain = window.location.hostname;
        const brand = isMisfitsTheme ? 'misfits_market' : 'imperfect_foods';

        trackEvent('quiz summary complete', {
            domain,
            brand,
            pathname,
        });

        setSignupLocalStorage({ path: '/join/account' });
        navigate('/join/account');
    };

    return <Button onClick={handleCreateAccount}>Create Account</Button>;
}
